import { Box, Flex, Spinner, Text } from "@chakra-ui/react";

const LoadingScreen = () => {
  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="white"
      zIndex="9999"
      direction="column"
      align="center"
      justify="center"
      gap={4}
    >
      <Spinner
        color="#11B882"
        size="xl"
      />
      <Text fontSize="lg" color="gray.600" fontWeight="medium">
        Loading...
      </Text>
    </Flex>
  );
};

export default LoadingScreen;
